<template>
  <div class="aiHelper d-flex">
    <div class="side-bar px-3 py-3 d-flex flex-column w-100 justify-content-between">
      <aside class="sidenav">
        <div class="mb-4">
          <img class="d-block object-contain h-auto w-100" src="@/assets/image/ai/AI_LOGO.png" alt="">
        </div>
        <ul class="sidenav__list text-white list-none p-0">
          <!-- <li class="sidenav__list_item mb-2" >
            <router-link :to="{ 'name': 'ai_assistantIntro' }" class="m-0 d-flex align-items-center p-2" :class="{ 'active': $route.name === 'ai_assistantIntro' }">
              <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2">使用指南
            </router-link>
          </li> -->
          <li class="sidenav__list_item mb-2">
            <a class="m-0 d-flex align-items-center p-2"><img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2">口說練習</a>
            <ul class="pl-0" v-if="menuData">
              <li class="sidenav__list_item" v-for="(value, key, index) in menuData" :key="index">
                <router-link :to="{ 'name': 'chatAI', 'params': { promptId: value } }" class="m-0 d-flex align-items-center p-2" :class="{ 'active': $route.name === 'chatAI' && $route.params.promptId === value }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">{{ key }}
                </router-link>
              </li>
            </ul>
          </li>
          <li class="sidenav__list_item mb-2">
            <a class="m-0 d-flex align-items-center p-2"><img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2">日語口說練習</a>
            <ul class="pl-0" v-if="menuData2">
              <li class="sidenav__list_item" v-for="(value, key, index) in menuData2" :key="index">
                <router-link :to="{ 'name': 'ChatAIJp', 'params': { promptId: value } }" class="m-0 d-flex align-items-center p-2" :class="{ 'active': $route.params.promptId === value }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">{{ key }}
                </router-link>
              </li>
            </ul>
          </li>
          <li class="sidenav__list_item mb-2">
            <a class="m-0 d-flex align-items-center p-2"><img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2">商用書信</a>
            <ul class="pl-0">
              <li class="sidenav__list_item" >
                <router-link :to="{ 'name': 'ai_assistantMain', 'params': { aiType: 'letter' } }" class="m-0 d-flex align-items-center p-2" :class="{ 'active': $route.name === 'ai_assistantMain' && $route.params.aiType === 'letter' }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">書信生成
                </router-link>
              </li>
              <li class="sidenav__list_item" >
                <router-link :to="{ 'name': 'ai_assistant_correction', 'params': { aiType: 'letter' } }" class="m-0 d-flex align-items-center p-2" :class="{ 'active': $route.name === 'ai_assistant_correction' && $route.params.aiType === 'letter' }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">AI批改
                </router-link>
              </li>
            </ul>
          </li>
          <li class="sidenav__list_item mb-2">
            <a class="m-0 d-flex align-items-center p-2"><img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2">英文演講稿</a>
            <ul class="pl-0">
              <li class="sidenav__list_item" >
                <router-link :to="{ 'name': 'ai_assistantMain', 'params': { aiType: 'speech' } }" class="m-0 d-flex align-items-center p-2" :class="{ 'active': $route.name === 'ai_assistantMain' && $route.params.aiType === 'speech' }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">演講稿生成
                </router-link>
              </li>
              <li class="sidenav__list_item" >
                <router-link :to="{ 'name': 'ai_assistant_correction', 'params': { aiType: 'speech' } }" class="m-0 d-flex align-items-center p-2" :class="{ 'active': $route.name === 'ai_assistant_correction' && $route.params.aiType === 'speech' }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">AI批改
                </router-link>
              </li>
              <li class="sidenav__list_item" >
                <router-link :to="{ 'name': 'ai_assistant_follow', 'params': { aiType: 'speech' } }" class="m-0 d-flex align-items-center p-2" :class="{ 'active': $route.name === 'ai_assistant_follow' && $route.params.aiType === 'speech' }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">跟讀練習
                </router-link>
              </li>
            </ul>
          </li>
          <!-- <li class="sidenav__list_item mb-2" >
            <router-link :to="{ 'name': 'records' }" class="m-0 d-flex align-items-center p-2" :class="{ 'active': $route.name === 'records' }">
              <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2">我的紀錄
            </router-link>
          </li> -->
        </ul>
      </aside>

    </div>
    <div class="side-bar-mobile px-4 py-3">
      <a v-if="!isShowMenu" class="w-100 d-flex align-items-center justify-content-between p-1 text-left bg-transparent" @click="isShowMenu = !isShowMenu">
        <div class="d-flex align-items-center">
          <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2">
          <div class="mr-2 text-white">{{ recentRoute }}</div>
        </div>
        <svg
          class="transition-transform text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </a>
      <div class="custom-dropdown" v-if="isShowMenu" :class="{ 'd-none': !isShowMenu }">
        <ul class="sidenav__list text-white list-none p-0 mb-0">
          <!-- <li class="sidenav__list_item mb-2" >
            <router-link @click.native="isShowMenu = false" :to="{ 'name': 'ai_assistantIntro' }" class="m-0 d-flex align-items-center p-1" :class="{ 'active': $route.name === 'ai_assistantIntro' }">
              <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2">使用指南
            </router-link>
          </li> -->
          <li class="sidenav__list_item" v-if="menuData">
            <a class="m-0 d-flex align-items-center p-1"><img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2">口說練習</a>
            <ul class="pl-0">
              <li class="sidenav__list_item" v-for="(value, key, index) in menuData" :key="index">
                <router-link @click.native="isShowMenu = false" :to="{ 'name': 'chatAI', 'params': { promptId: value } }" class="m-0 d-flex align-items-center p-1" :class="{ 'active': $route.name === 'chatAI' && $route.params.promptId === key }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">{{ key }}
                </router-link>
              </li>
            </ul>
          </li>
          <li class="sidenav__list_item" v-if="menuData2">
            <a class="m-0 d-flex align-items-center p-1"><img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2">日語口說練習</a>
            <ul class="pl-0">
              <li class="sidenav__list_item" v-for="(value, key, index) in menuData2" :key="index">
                <router-link @click.native="isShowMenu = false" :to="{ 'name': 'ChatAIJp', 'params': { promptId: value } }" class="m-0 d-flex align-items-center p-1" :class="{ 'active': $route.name === 'chatAI' && $route.params.promptId === key }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">{{ key }}
                </router-link>
              </li>
            </ul>
          </li>
          <li class="sidenav__list_item">
            <a class="m-0 d-flex align-items-center p-1"><img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2">商用書信</a>
            <ul class="pl-0">
              <li class="sidenav__list_item" >
                <router-link @click.native="isShowMenu = false" :to="{ 'name': 'ai_assistantMain', 'params': { aiType: 'letter' } }" class="m-0 d-flex align-items-center p-1" :class="{ 'active': $route.name === 'ai_assistantMain'  && $route.params.aiType === 'letter' }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">書信生成
                </router-link>
              </li>
              <li class="sidenav__list_item" >
                <router-link  @click.native="isShowMenu = false" :to="{ 'name': 'ai_assistant_correction', 'params': { aiType: 'letter' } }" class="m-0 d-flex align-items-center p-1" :class="{ 'active': $route.name === 'ai_assistant_correction' && $route.params.aiType === 'letter' }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">AI批改
                </router-link>
              </li>
            </ul>
          </li>
          <li class="sidenav__list_item">
            <a class="m-0 d-flex align-items-center p-1"><img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2">英文演講</a>
            <ul class="pl-0">
              <li class="sidenav__list_item" >
                <router-link @click.native="isShowMenu = false" :to="{ 'name': 'ai_assistantMain', 'params': { aiType: 'speech' } }" class="m-0 d-flex align-items-center p-1" :class="{ 'active': $route.name === 'ai_assistantMain' && $route.params.aiType === 'speech' }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">演講稿生成
                </router-link>
              </li>
              <li class="sidenav__list_item" >
                <router-link @click.native="isShowMenu = false" :to="{ 'name': 'ai_assistant_correction', 'params': { aiType: 'speech' } }" class="m-0 d-flex align-items-center p-1" :class="{ 'active': $route.name === 'ai_assistant_correction' && $route.params.aiType === 'speech' }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">AI批改
                </router-link>
              </li>
              <li class="sidenav__list_item" >
                <router-link @click.native="isShowMenu = false" :to="{ 'name': 'ai_assistant_follow', 'params': { aiType: 'speech' } }" class="m-0 d-flex align-items-center p-1" :class="{ 'active': $route.name === 'ai_assistant_follow' && $route.params.aiType === 'speech' }">
                  <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 opacity-0">跟讀練習
                </router-link>
              </li>
            </ul>
          </li>
        </ul>

      </div>
    </div>
    <div class="contain-main">
      <router-view class="py-2 py-md-0" :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>

<script>
  import api from '@/store/api'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    name: 'Layout',
    data () {
      return {
        selectedIdx: 1,
        menuData: null,
        menuData2: null,

        isShowMenu: false
      }
    },
    computed: {
      ...mapGetters(['remainPoints']),
      recentRoute () {
        const { name, params } = this.$route

        if (name === 'ai_assistantIntro') return '使用指南'

        if (name === 'ai_assistantMain') {
          return params.aiType === 'letter' ? '書信生成' :
                params.aiType === 'speech' ? '演講稿生成' : '使用指南'
        }

        if (name === 'ai_assistant_correction') {
          return params.aiType === 'letter' ? 'AI批改' :
                params.aiType === 'speech' ? 'AI批改' : '使用指南'
        }

        if (name === 'chatAI' && this.menuData) {
          if (params.promptId === this.menuData['商業英語會話']) return '商業英語會話'
          if (params.promptId === this.menuData['生活英語會話']) return '生活英語會話'
        }

        if (name === 'ai_assistant_follow') {
          return '跟讀練習'
        }

        return '使用指南'
      }
    },
    mounted () {
      this.$store.dispatch('getRemainPoints')
      this.getMenu()
      this.getMenu2()
    },
    methods: {
      getMenu () {
        let self = this

        let path = `/ai/categories/list`
        const options = { headers: { 'showLoading': true }}
        api.get(path, options)
        .then((res) => {
          self.menuData = res.data
        })
      },
      getMenu2 () {
        let self = this

        let path = `/ai/categories/list?lang=ja-JP`
        const options = { headers: { 'showLoading': true }}
        api.get(path, options)
        .then((res) => {
          self.menuData2 = res.data
        })
      }
    }
  }
</script>
<style lang="scss">
  .aiHelper {
    @media (max-width: 511px) {
      margin-top: 117px;
    }
    svg {
      width: 1.25rem;
      height: 1.25rem;
      color: white;
    }
    overflow: hidden;
    text-align: left;
    // flex-wrap: wrap;
    @media (max-width: 769px) {
      flex-wrap: wrap;
    }
    .side-bar {
      background: #0E103E;
      max-width: 260px;
      width: 100%;
      @media (max-width: 769px) {
        max-width: 100%;
        display: none !important;
      }
      ul {
        list-style: none;
        list-style-position: inside;
        li {
          p {
            font-weight: 700;
            font-size: 1.125rem;
          }
          a {
            color: white;
            // font-weight: 700;
            font-size: 1.125rem;
            border-radius: 8px;
            white-space: nowrap;
            &:hover {
              background: rgb(255, 255, 255, 0.2);
              text-decoration: none;
            }

          }
          .active {
            background: linear-gradient(180deg, #F94F39 0%, #FF763C 100%);
          }
        }
      }
    }
    .side-bar-mobile {
      ul {
        list-style: none;
        list-style-position: inside;
        li {
          p {
            font-weight: 700;
            font-size: 1.125rem;
          }
          a {
            color: white;
            // font-weight: 700;
            font-size: 1.125rem;
            border-radius: 8px;
            white-space: nowrap;
            &:hover {
              background: rgb(255, 255, 255, 0.2);
              text-decoration: none;
            }

          }
          .active {
            background: linear-gradient(180deg, #F94F39 0%, #FF763C 100%);
          }
        }
      }
      background: #0E103E;
      width: 100%;
      @media (min-width: 769px) {
        display: none;
      }
      .custom-dropdown {
        font-size: 15px;
      }
    }
    .contain-main {
      background: #eaedf2;
      min-height: 100vh;
      width: 100%;
      @media (min-width: 1023px) {
        width: calc(100vw - 260px);
      }
    }
    p {
      margin: 0;
      white-space: normal;
    }
  }

  .transition-transform {
      transition-property: transform;
      transition-timing-function: cubic-bezier(.4,0,.2,1);
      transition-duration: .15s;
  }
</style>
